import './polls.less';

App.Pages.PollsQuestions = class PollsQuestions extends PF.Page
{

	static get options()
	{
		return {
			rights: {
				guest: true,
				user: true
			},
			panel: false,
			path: '/poll-questions',
			nameRu: 'Опрос - Вопросы',
		};
	}

	static get template()
	{
		//language=HTML
		return /*html*/`
            <div class="page polls">
				<div class="page-content" pf="pageContent"></div>
			</div>
		`;
	}

	init()
	{
		super.init();
		if (this.user === null || this.user === undefined)
		{
			app.panelState = null;
		} else
		{
			app.panelDisplay(0);
		}
		this.dom.pageContent.css('height', '100%');
		//
		this.poll_id = app.pageParams.poll_id;
		this.type = app.pageParams.type;
		this.return = app.pageParams.return;
		//
		this.poll = new PF.Model({
			represent: "polls/View",
			saveOnModify: false,
			where: `id ='${this.poll_id}'`
		});
		this.poll.onValue('options.loadStatus', 'loaded', () =>
		{
			switch (this.type)
			{
				case 'poll-questions-scroll':
				case 'scroll':
					this.question = new QuestionsTypeScroll({
						dom: this.dom,
						poll: this.poll,
						html: QuestionsTypeScroll.templates
					})
					break;
				case 'poll-questions-step':
				case 'step':
				default:
					this.question = new QuestionsTypeStep({
						dom: this.dom,
						poll: this.poll,
						html: QuestionsTypeStep.templates
					})
					break;
			}
		});
		//
	}
};

class QuestionsTypeBase extends PF.Widget
{
	static get options()
	{
		return {
			dom: {},
			poll: {},
			page: {},
			html: QuestionsTypeBase.templates
		};
	}

	static get templates()
	{
		//language=HTML
		return {
			question: /*html*/`<div>Что-то пошло не так</div>`,
		};
	}

	init()
	{
		this.dom.loads(this.html, 'question');
		this.dom.question.bindObject(this);
		this.dom.pageContent.prepend(this.dom.question);
		super.init();
		//
		this.dom.pollTitle.bindHtml();
		this.dom.pollQr.bindHtml();
		this.dom.pollTitle.html = this.poll.title;
		this.dom.pollQr.html = `<img src="` + this.poll.img_qr + `"/>`;
		//
		this.questionsTimer = 30 * 1000;
		this.loadStatus = false;
		this.time;
		// получаем время для таймера простоя
		app.request('/settings/get', { target: 'questions-timer' }, (response) =>
		{
			this.response = response;
			if (this.response.status != 'FAIL')
			{
				if (this.response.data != null)
				{
					let type = typeof (this.response.data);
					if (type == 'number')
					{
						this.questionsTimer = this.response.data * 1000;
					}
				}
			}
		});
		//
		this.surveyResult = new PF.Model({ // результат опроса
			represent: "polls/Passing",
			loadOnInit: false,
			isNewRecord: true,
			saveOnModify: true,
			raw: {
				poll_id: this.poll.id,
				result: new Array(),
				start_at: DateTime.local(),
				end_at: DateTime.local(),
			}
		});
		this.survey = new PF.Model({ // настройки
			raw: {
				dt: DateTime.local(),
				questionsNumber: 1,
				step: 1,
			}
		});
		this.survey.onChange('dt', () => // событие на обновление даты ответа на вопрос
		{
			this.resetTimer();
		}, true);
		this.listQuestions = new PF.List({ // сами вопросы
			dom: {
				element: this.dom.list,
			},
			html: {
				header: {},
				wrapper: `<div class="col-100" pf="wrapper"><div class="row" pf="ul"></div></div>`,
				preloaderContent: ``,
			},
			searchable: false,
			modelsConfig: {
				represent: 'polls/Questions',
				where: `poll_id ='${this.poll.id}'`
			},
			itemClass: QuestionsList,
			widget: this,
		});
		// кнопка завершения
		this.dom.buttonEnd.on("click", () =>
		{
			clearTimeout(this.time);
			this.exitPoll();
		});
	}

	/**
	 * Выход из опроса по таймеру
	 * @param {QuestionsTypeBase} page 
	 */
	logout(page)
	{
		app.toast("Время опроса истекло...");
		page.exitPoll();
	}

	/**
	 * Сброс таймера простоя
	 */
	resetTimer()
	{
		clearTimeout(this.time);
		this.time = setTimeout(this.logout, this.questionsTimer, this);
		// 1000 milliseconds = 1 second
	}

	/**
	 * завершение опроса
	 * @param {string} router 
	 */
	exitPoll(router = '/poll-end')
	{
		// сохраняем результат, если даны ответа на все вопросы
		if (this.surveyResult.result.length == this.listQuestions.length)
		{
			this.surveyResult.end_at = DateTime.local();
			this.surveyResult.save();
			this.surveyResult.on('save-success', () =>
			{
				app.router.navigate(router);
			}, true);
		} else
		{
			app.router.navigate(router);
		}
	}
}

class QuestionsTypeScroll extends QuestionsTypeBase
{
	static get templates()
	{
		//language=HTML
		return {
			question: /*html*/`
		<div class="questions-step">
			<div class="row" style="top: 13px">
				<div class="col-100" style="text-align: center;"><br/>
					<img width="180px" height="62.2px" src="/img/Служба крови лого.svg"/>
				</div>
			</div>
			<div class="row">
				<div class="col-100 textbox" pf="back">
					<p class="align-left-1 back blue-100"><img src="/img/back.svg"/></p>
					<p class="align-left-2 blue-100">Назад</p>
					<p class="align-center title" pf="pollTitle"></p>
				</div>
			</div>
			<div class="row questions-list" pf="list"></div>
			<div class="row">
				<div class="col-100 card">
					<div class="card-header card-content-padding blue-100" style="justify-content: center;">
						Хотели бы сказать больше? Оставьте текстовый отзыв!
					</div>
					<div class="card-content" style="text-align: center;">
						<div pf="pollQr" class="img-qr" style="margin-top: 20px"></div><br/>
						Отсканируйте QR-код на телефоне и сообщите больше информации.<br/>
						Ваше мнение поможет сделать работу Центра крови лучше!
					</div>
				</div>
			</div>
			<div class="row">
				<button class="col-100 button" type="button" pf="buttonEnd">Завершить опрос</button>
			</div>
			<div class="row">
				<br/>
			</div>
		</div>
		`};
	}
	init()
	{
		this.type = 'list';
		super.init();
		// кнопка назад: возвращает к списку опросов
		this.dom.back.on("click", () =>
		{
			clearTimeout(this.time);
			this.exitPoll('/polls');
		});
	}
}

class QuestionsTypeStep extends QuestionsTypeBase
{
	static get templates()
	{
		//language=HTML
		return {
			question: /*html*/`
		<div class="questions-step">
			<div class="row" style="margin-top: 130px;">
				<div class="col-100" style="text-align: center;">
					<img class="logo" src="/img/Служба крови лого.svg"/>
				</div>
			</div>
			<div class="row" style="margin-top: 300px;">
				<div class="col-100 textbox" pf="back">
					<p class="align-left-1 back blue-100"><img src="/img/back.svg"/></p>
					<p class="align-left-2 blue-100">Назад</p>
					<p class="align-center title" pf="pollTitle"></p>
				</div>
			</div>
			<div class="row">
				<div class="col-100" style="text-align: center;">
					<ul class="q-progressbar" pf="progressbar"></ul>
				</div>
			</div>
			<div class="row questions-list" style="margin-top: 50px;" pf="list"></div>
			<div pf="lastStep">
				<div class="row">
					<div class="col-100 card">
						<div class="card-header card-content-padding blue-100" style="justify-content: center;">
							Хотели бы сказать больше? Оставьте текстовый отзыв!
						</div>
						<div class="card-content" style="text-align: center;">
							<div pf="pollQr" class="img-qr" style="margin-top: 20px"></div><br/>
							Отсканируйте QR-код на телефоне и сообщите больше информации.<br/>
							Ваше мнение поможет сделать работу Центра крови лучше!
						</div>
					</div>
				</div>
				<div class="row">
					<button class="col-100 button" type="button" pf="buttonEnd">Завершить опрос</button>
				</div>
			</div>
			<div class="row">
				<br/>
			</div>
		</div>
		`};
	}
	init()
	{
		this.type = 'step';
		super.init();
		this.bindDom({ lastStep: 'show' }, 'loadStatus');
		// кнопка назад: возвращает к предыдущему вопросу или к списку опросов
		this.dom.back.on("click", () =>
		{
			this.survey.setData('step', this.survey.get('step') - 1, true);
			this.survey.setData('dt', DateTime.local(), true);  // сбрасываем таймер бездействия
			if (this.survey.step == 0)
			{
				clearTimeout(this.time);
				this.exitPoll('/polls');
			}
		});
		this.survey.onChange('step', () =>
		{
			if (this.survey.step == (this.listQuestions.length + 1) && this.listQuestions.length > 0)
			{
				this.loadStatus = true;
			} else
			{
				this.loadStatus = false;
			}
			this.updateProgress();
		}, true);
		this.initProgressbar();
	}

	initProgressbar()
	{
		this.listQuestions.on('addOne', (e) =>
		{
			if (this.listQuestions.length > 0)
			{
				this.dom.progressbar.append('<li></li>');
			this.updateProgress();
			}
		}, true);
	}
	updateProgress()
	{
		if (this.dom.progressbar.node.childNodes.length > 0)
		{
			this.dom.progressbar.node.childNodes.forEach((item, index) =>
			{
				let step = this.survey.get('step') - 1;
				if (index === step)
				{
					item.classList.remove("complied");
					item.classList.add("active");
				} else if (index < step)
				{
					item.classList.remove("active");
					item.classList.add("complied");
				} else
				{
					item.classList.remove("active");
					item.classList.remove("complied");
				}
			});
		}
	}
}

/**
 * Формируем список вопросов опроса
 */
class QuestionsList extends PF.List.Item
{
	get renderer()
	{
		//language=HTML
		return /*html*/`
		<div class="col-100 card" pf="question">
			<div class="card-header blue-100">
				<b>@{model.number}. @{model.text}</b>
			</div>
			<div class="card-content" pf="answers"></div>
		</div>
		`;
	}

	onRender()
	{
		this.model.number = this.list.widget.survey.questionsNumber;
		this.list.widget.survey.questionsNumber++;
		super.onRender();
		switch (this.model.type.type)
		{
			case 'Closed:Single Choice':
				this.closedSingle();
				break;
			// todo: остальные типы вопросов
			case 'Closed:Multiple Choice':
			case 'Semi-closed':
			case 'Open':
			case 'YesNo':
			case 'Scale':
			default:
				break;
		}
		if (this.list.widget.type == 'step')
		{
			// показать вопрос, если текущий шаг = номер вопроса
			this.bindDom({ question: 'show' }, 'list.widget.survey.step', (s) => s === this.model.number);
		}
	}

	closedSingle()
	{
		this.passing = 0;
		this.answers = new PF.List({
			dom: {
				element: this.dom.answers,
			},
			html: {
				header: {},
				wrapper: `<div pf="wrapper" style="margin: 5px;"><div class="row" pf="ul"></div></div>`,
				preloaderContent: ``,
			},
			models: this.model.answers,
			searchable: false,
			itemClass: AnswersClosedSingle,
			question: this.model,
			passing: this.passing,
			surveyResult: this.list.widget.surveyResult,
			survey: this.list.widget.survey,
			type: this.list.widget.type,
		});

		// for (let i = 0; i < this.answers.length; i++)
		// {
		// 	this.answer = this.answers[i];
		// 	console.log(this.answer);

		// }
	}
}

/**
 * Формирует список ответов на вопрос
 */
class AnswersClosedSingle extends PF.List.Item
{
	get renderer()
	{
		//language=HTML
		return /*html*/`
		<div class="col-100">
			<button class="button button-answer" type="button" id="@{model.id}" pf="buttonAnswer">@{model.text}</button>
		</div>
		`;
	}

	onRender()
	{
		super.onRender();
		this.list.survey.setData('dt', DateTime.local(), true); // сбрасываем таймер
		// подсветка выбранного ответа
		this.bindDom({ buttonAnswer: 'class:button-active' }, 'list.passing', (s) => s === this.model.id);
		// добавляем или обновляем ответ на вопрос
		this.dom.buttonAnswer.on("click", () =>
		{
			this.list.passing = this.model.id;
			// Find the index of an object with a specific property value
			let index = this.list.surveyResult.result.findIndex((item) => item.question === this.list.question.id);
			// Check if the object with the specified property value exists in the array
			if (index === -1)
			{
				// If not found, push a new object with the desired properties
				this.list.surveyResult.result.push({ 'question': this.list.question.id, 'answer': this.model.id });
			} else
			{
				// If found, update
				this.list.surveyResult.result[index].answer = this.model.id;
			}
			//
			this.list.survey.setData('dt', DateTime.local(), true); // сбрасываем таймер бездействия
			if (this.list.type == 'step')
			{
				// увеличить счётчик для перехода к следующему вопросу
				let newStep = this.list.survey.get('step') + 1;
				Util.sleep(500).then(() =>
				{
					// даём немного времени на анимацию и затем переходим + исключая двойное/тройное нажатие на ответ
					this.list.survey.setData('step', newStep, true);
				});
			}
		});
	}
}